import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState, AppThunk } from "../../app/store";
import { fetchCounsellorSearch } from "./helpAndAssistantApi";

export interface CounsellorSearchState {
  counsellor: any;
  status: "idle" | "loading" | "failed" | "success";
  accessToken : string;
}

const initialState: CounsellorSearchState = {
  counsellor: [],
  status: "idle",
  accessToken : '',
};

export const GetCounsellorSearch = createAsyncThunk(
  "Counsellor/fetchCounsellorSearch",
  async (data: any) => {
    const response = await fetchCounsellorSearch(data);
    return response;
  }
);

export const counsellorSearchSlice = createSlice({
  name: "Counsellor",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(GetCounsellorSearch.pending, (state) => {
        state.status = "loading";
      })
      .addCase(GetCounsellorSearch.rejected, (state, action) => {
        state.status = "failed";
      })
      .addCase(GetCounsellorSearch.fulfilled, (state, action) => {
        //if(action.payload.status == 200) {
          state.status = "success";
          state.counsellor=action.payload;
         // state.accessToken = action.payload.data.accessToken;
         // localStorage.setItem('userDetails', JSON.stringify(action.payload.data));
        // }else {
        //   state.status = "failed"
        // }
       
      });
  },
});

export const {} = counsellorSearchSlice.actions;

export const selectCounsellorSearch = (state: RootState) => {
  return state.Counsellor.counsellor;
};

export default counsellorSearchSlice.reducer;
